package org.vreo.devicehub.features.core.domain.device.singleShootAutoFocus

/**
 * Single shot autofocus
 *
 * @property config device/platfrom specific encoded configuration
 */
data class SingleShotAutoFocusConfig(
    val config: String = ""
)
